module.exports = __webpack_public_path__ + "img/022-hire.84200e5d.svg";